interface IConfigScheme {
  URL_API: string
  name: string
}

const normalizeApiUrl = (value: string) =>
  value.endsWith("/") ? value : `${value}/`

const apiUrl = normalizeApiUrl(
  import.meta.env.VITE_API_URL || "https://cardpartner.net/api/v2/"
)

class Config {
  static scheme: IConfigScheme = {
    URL_API: apiUrl,
    name: import.meta.env.DEV ? "development" : "production"
  }

  /** KYC dashboard page of one module session; the session uid is appended. */
  static kycSessionUrl = (session: string) =>
    normalizeApiUrl(import.meta.env.VITE_KYC_DASHBOARD_URL || "https://kyc.impaya.com/dashboard/") +
    "sessions/" + encodeURIComponent(session)
}

export default Config
